export function camelToSnake(str: string): string {
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

export function toSnakeCaseKeys(obj: Record<string, any>): Record<string, any> {
    const result: Record<string, any> = {}

    for (const key in obj) {
        if (!obj.hasOwnProperty(key)) continue
        const value = obj[key]
        const newKey = camelToSnake(key)

        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            result[newKey] = toSnakeCaseKeys(value) // recurse on nested config
        } else {
            result[newKey] = value
        }
    }

    return result
}
